import { avc1 } from './avc1.js';
/**
 * Parse a VisualSampleEntryBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed VisualSampleEntryBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function avc3(view) {
    return avc1(view);
}
//# sourceMappingURL=avc3.js.map